export class EditProfileController {
    constructor($scope, $rootScope, $http, UserService, RegionService, CityService, toastr) {
        $scope.vm = this;
        this.scope = $scope;
        this.rootScope = $rootScope;
        this.http = $http;
        this.UserService = UserService;
        this.RegionService = RegionService;
        this.CityService = CityService;
        this.scope.regions = [];
        this.scope.allCities = [];
        this.scope.cities = [];
        this.scope.oldShortDescription = '';
        this.toastr = toastr;
        this.init();
    }

    init() {
      this.scope.changeRegion = () => {
        this.scope.cities = [];
        let region = this.scope.currentUserProfile.region;
        _.forEach(this.scope.allCities, (city) => {
          if(city.region == region) {
            this.scope.cities.push(city);
          }
        })
      }

      async.parallel([
        callback => {
          this.RegionService.getRegionsList()
          .then((response) => { let regions = response.data;
            this.scope.regions = [];
            _.forEach(regions.data, (region) => {
              this.scope.regions.push(region);
            })

            callback();
          })
          .catch((response) => { let error = response.data;
            console.error(err);
            callback();
          });
        },

        callback => {
          this.CityService.getCitiesList()
            .then((response) => { let cities = response.data;
              this.scope.allCities = [];
              _.forEach(cities.data, (city) => {
                this.scope.allCities.push(city);
              })
              callback();
            })
            .catch((response) => { let error = response.data;
              console.error(err);
              callback();
            });
        },

        callback => {
          this.UserService.getCurrentUser()
          .then((response) => { let user = response.data;
            this.rootScope.currentUserProfile = user.data;
            this.scope.currentUserProfile = angular.copy(user.data);
            this.scope.oldShortDescription = this.scope.currentUserProfile.informationPersonal.shortDescription;
            callback();
          })
          .catch((response) => { let err = response.data;
            console.error(err);
            callback();
          });
        }
      ], () => {
        this.scope.changeRegion();
      })
    }

    updateUserProfile() {
      if(this.scope.currentUserProfile.informationPersonal.shortDescription === '') {
        this.scope.currentUserProfile.informationPersonal.shortDescriptionApproved = true;
      } else if(this.scope.currentUserProfile.informationPersonal.shortDescription !== this.scope.oldShortDescription) {
        this.scope.currentUserProfile.informationPersonal.shortDescriptionApproved = false;
      }

      this.UserService.updateUser(this.scope.currentUserProfile)
        .then((response) => {
          this.toastr.info('Perfil actualizada con exito');
          this.rootScope.getWizard();
        })
        .catch((response) => { let error = response.data; let status = response.status;
          if(status == 409) {
            this.toastr.warning('No hay cambios para guardar');
          } else {
            console.error(err);
          }
        });
    }

    listHeight() {
      let arrayHeight = [];
      arrayHeight.push("");

      for(var i = 140; i < 221; i++) {
        arrayHeight.push(i);
      }

      return arrayHeight;
    }

    listWeight() {
      let arrayWeight = [];
      arrayWeight.push("");

      for(var i = 40; i < 201; i++) {
        arrayWeight.push(i);
      }

      return arrayWeight;
    }
}
